import { render, staticRenderFns } from "./RoleList.vue?vue&type=template&id=6e47f879&"
import script from "./RoleList.vue?vue&type=script&lang=js&"
export * from "./RoleList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e47f879')) {
      api.createRecord('6e47f879', component.options)
    } else {
      api.reload('6e47f879', component.options)
    }
    module.hot.accept("./RoleList.vue?vue&type=template&id=6e47f879&", function () {
      api.rerender('6e47f879', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/examples/list/RoleList.vue"
export default component.exports